export default __webpack_public_path__ + "static/media/ic_cake_24.115af51d.svg";